import { PERSONAL_DATA, PRIVACY_POLICY } from 'shared/constants/links';
import styles from './styles.css';
import { Button, Checkbox, FormField, Input, MaskedInput } from '@cian/ui-kit';
import { NBSP } from 'shared/constants/symbols';
import { useUrlWithUtm } from 'shared/hooks';

interface IModalFormProps {
  name: string;
  phone: string;
  email: string;
  isAgreed: boolean;
  errors: { name?: string; phone?: string; email?: string; agreement?: string };
  isLoading: boolean;
  onNameChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onAgreementChange: (value: boolean) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export const ModalForm: React.FC<IModalFormProps> = ({
  name,
  phone,
  email,
  isAgreed,
  errors,
  isLoading,
  onNameChange,
  onPhoneChange,
  onEmailChange,
  onAgreementChange,
  onSubmit,
}) => {
  const privacyPolicyUrl = useUrlWithUtm(PRIVACY_POLICY);

  return (
    <form onSubmit={onSubmit} className={styles['container']}>
      <div className={styles['textblock']}>
        <div className={styles['title']}>
          Добро пожаловать на{NBSP}Циан{NBSP}Посуточно!{' '}
        </div>
        <div className={styles['description']}>
          Чтобы получить 1000 бонусов на продвижение, оставьте ваши контакты в форме
        </div>
      </div>
      <div className={styles['form']}>
        <FormField label="ФИО" errorMessage={errors.name}>
          <Input
            placeholder="Ваше ФИО"
            size="M"
            value={name}
            onChange={e => onNameChange(e.target.value)}
            disabled={isLoading}
          />
        </FormField>
        <FormField label="Телефон" errorMessage={errors.phone}>
          <MaskedInput
            mask="+7 000 000 00-00"
            size="M"
            placeholderChar="+"
            placeholder="+7"
            lazy
            value={phone}
            onChange={onPhoneChange}
            disabled={isLoading}
          />
        </FormField>
        <FormField label="E-mail" errorMessage={errors.email}>
          <Input
            size="M"
            placeholder="example@mail.ru"
            value={email}
            onChange={e => onEmailChange(e.target.value)}
            disabled={isLoading}
          />
        </FormField>
        <FormField errorMessage={errors.agreement}>
          <Checkbox
            checked={isAgreed}
            onChange={e => onAgreementChange(e.target.checked)}
            disabled={isLoading}
            label={
              <div className={styles['notice']}>
                Согласен на{' '}
                <a className={styles['link']} href={PERSONAL_DATA} target="_blank" rel="noreferrer">
                  обработку персональных данных
                </a>{' '}
                в соответствии с{NBSP}
                <a className={styles['link']} href={privacyPolicyUrl} target="_blank" rel="noreferrer">
                  Политикой{NBSP}конфиденциальности
                </a>
              </div>
            }
          />
        </FormField>
      </div>
      <div className={styles['btn']}>
        <Button type="submit" fullWidth loading={isLoading} disabled={isLoading}>
          Отправить
        </Button>
      </div>
    </form>
  );
};
